import { TranslationService } from '../services/translation.service'
import { MeasurementType } from '../types/measurementTypes'

const translationService = new TranslationService()

export const MEASUREMENT_TYPES: Array<MeasurementType> = [
  {
    name: translationService.getKilogramText(),
    shortName: translationService.getKgText(),
  },
  {
    name: translationService.getPoundText(),
    shortName: translationService.getLbText(),
  },
  {
    name: translationService.getGramText(),
    shortName: translationService.getGText(),
  },
  {
    name: translationService.getTonsText(),
    shortName: translationService.getTnText(),
  },
  {
    name: translationService.getMetricTonText(),
    shortName: translationService.getMpText(),
  },
  {
    name: translationService.getLiterText(),
    shortName: translationService.getLtText(),
  },
  {
    name: translationService.getGallonText(),
    shortName: translationService.getGaText(),
  },
  {
    name: translationService.getOunceText(),
    shortName: translationService.getOzText(),
  },
  {
    name: translationService.getTroyOunceText(),
    shortName: translationService.getTozText(),
  },
  {
    name: translationService.getPintText(),
    shortName: translationService.getPtText(),
  },
  {
    name: translationService.getQuartText(),
    shortName: translationService.getQtText(),
  },
  {
    name: translationService.getCentimeterText(),
    shortName: translationService.getCmText(),
  },
  {
    name: translationService.getKilometersText(),
    shortName: translationService.getDkText(),
  },
  {
    name: translationService.getMilligramText(),
    shortName: translationService.getMgText(),
  },
  {
    name: translationService.getThousandText(),
    shortName: translationService.getThText(),
  },
  {
    name: translationService.getCubicCentimeterText(),
    shortName: translationService.getCcText(),
  },
  {
    name: translationService.getCubicMetersText(),
    shortName: translationService.getCrText(),
  },
  {
    name: translationService.getCubicFootText(),
    shortName: translationService.getCfText(),
  },
  {
    name: translationService.getSquareFootText(),
    shortName: translationService.getSfText(),
  },
  {
    name: translationService.getBarrelText(),
    shortName: translationService.getBrText(),
  },
  {
    name: translationService.getMilliliterText(),
    shortName: translationService.getMlText(),
  },
  {
    name: translationService.getCentiliterText(),
    shortName: translationService.getC3Text(),
  },
  {
    name: translationService.getMillimeterText(),
    shortName: translationService.getMmText(),
  },
  {
    name: translationService.getMetersText(),
    shortName: translationService.getMrText(),
  },
  {
    name: translationService.get10PackText(),
    shortName: translationService.getTpText(),
  },
  {
    name: translationService.get100PackText(),
    shortName: translationService.get4fText(),
  },
  {
    name: translationService.get1000PackText(),
    shortName: translationService.getZrText(),
  },
  {
    name: translationService.get120PackText(),
    shortName: translationService.getZnText(),
  },
  {
    name: translationService.get13PackText(),
    shortName: translationService.getZ7Text(),
  },
  {
    name: translationService.get14PackText(),
    shortName: translationService.getZ9Text(),
  },
  {
    name: translationService.get15PackText(),
    shortName: translationService.getZsText(),
  },
  {
    name: translationService.get150PackText(),
    shortName: translationService.getZoText(),
  },
  {
    name: translationService.get16PackText(),
    shortName: translationService.getZfText(),
  },
  {
    name: translationService.get18PackText(),
    shortName: translationService.getH3Text(),
  },
  {
    name: translationService.get2PackText(),
    shortName: translationService.getOpText(),
  },
  {
    name: translationService.get20PackText(),
    shortName: translationService.get4eText(),
  },
  {
    name: translationService.get200PackText(),
    shortName: translationService.getZqText(),
  },
  {
    name: translationService.get22PackText(),
    shortName: translationService.getH5Text(),
  },
  {
    name: translationService.get24PackText(),
    shortName: translationService.getQ7Text(),
  },
  {
    name: translationService.get25PackText(),
    shortName: translationService.getQ5Text(),
  },
  {
    name: translationService.get250PackText(),
    shortName: translationService.getU5Text(),
  },
  {
    name: translationService.get3PackText(),
    shortName: translationService.getP3Text(),
  },
  {
    name: translationService.get30PackText(),
    shortName: translationService.getH6Text(),
  },
  {
    name: translationService.get36PackText(),
    shortName: translationService.getQ6Text(),
  },
  {
    name: translationService.get38PackText(),
    shortName: translationService.getH7Text(),
  },
  {
    name: translationService.get4PackText(),
    shortName: translationService.getP4Text(),
  },
  {
    name: translationService.get48PackText(),
    shortName: translationService.getZgText(),
  },
  {
    name: translationService.get5PackText(),
    shortName: translationService.getP5Text(),
  },
  {
    name: translationService.get50PackText(),
    shortName: translationService.getQ4Text(),
  },
  {
    name: translationService.get500PackText(),
    shortName: translationService.getVcText(),
  },
  {
    name: translationService.get5000PackText(),
    shortName: translationService.getJ8Text(),
  },
  {
    name: translationService.get52PackText(),
    shortName: translationService.getZiText(),
  },
  {
    name: translationService.get6PackText(),
    shortName: translationService.getP6Text(),
  },
  {
    name: translationService.get60PackText(),
    shortName: translationService.getZjText(),
  },
  {
    name: translationService.get62PackText(),
    shortName: translationService.getH8Text(),
  },
  {
    name: translationService.get7PackText(),
    shortName: translationService.getP7Text(),
  },
  {
    name: translationService.get72PackText(),
    shortName: translationService.getZkText(),
  },
  {
    name: translationService.get75PackText(),
    shortName: translationService.getH9Text(),
  },
  {
    name: translationService.get8PackText(),
    shortName: translationService.getP8Text(),
  },
  {
    name: translationService.get9PackText(),
    shortName: translationService.getP9Text(),
  },
  {
    name: translationService.get96PackText(),
    shortName: translationService.getJ7Text(),
  },
  {
    name: translationService.getAssemblyText(),
    shortName: translationService.getAyText(),
  },
  {
    name: translationService.getAssortmentText(),
    shortName: translationService.getAsText(),
  },
  {
    name: translationService.getBagText(),
    shortName: translationService.getBgText(),
  },
  {
    name: translationService.getBaleText(),
    shortName: translationService.getBaText(),
  },
  {
    name: translationService.getBatchText(),
    shortName: translationService.get5bText(),
  },
  {
    name: translationService.getBinText(),
    shortName: translationService.get2wText(),
  },
  {
    name: translationService.getBoardFeetText(),
    shortName: translationService.getBfText(),
  },
  {
    name: translationService.getBottleText(),
    shortName: translationService.getBoText(),
  },
  {
    name: translationService.getBoxText(),
    shortName: translationService.getBxText(),
  },
  {
    name: translationService.getBucketText(),
    shortName: translationService.getBcText(),
  },
  {
    name: translationService.getBundleText(),
    shortName: translationService.getBdText(),
  },
  {
    name: translationService.getCanText(),
    shortName: translationService.getCnText(),
  },
  {
    name: translationService.getCardText(),
    shortName: translationService.getCgText(),
  },
  {
    name: translationService.getCartonText(),
    shortName: translationService.getCtText(),
  },
  {
    name: translationService.getCaseText(),
    shortName: translationService.getCaText(),
  },
  {
    name: translationService.getCassetteText(),
    shortName: translationService.getCsText(),
  },
  {
    name: translationService.getCoilText(),
    shortName: translationService.getCxText(),
  },
  {
    name: translationService.getConeText(),
    shortName: translationService.getCjText(),
  },
  {
    name: translationService.getContainerText(),
    shortName: translationService.getChText(),
  },
  {
    name: translationService.getCrateText(),
    shortName: translationService.getCpText(),
  },
  {
    name: translationService.getCubicDecimeterText(),
    shortName: translationService.getC8Text(),
  },
  {
    name: translationService.getCubicYardText(),
    shortName: translationService.getCyText(),
  },
  {
    name: translationService.getCupText(),
    shortName: translationService.getCuText(),
  },
  {
    name: translationService.getCylinderText(),
    shortName: translationService.getClText(),
  },
  {
    name: translationService.getDaysText(),
    shortName: translationService.getDaText(),
  },
  {
    name: translationService.getDealText(),
    shortName: translationService.getDeText(),
  },
  {
    name: translationService.getDeciliterText(),
    shortName: translationService.getDlText(),
  },
  {
    name: translationService.getDecimeterText(),
    shortName: translationService.getDmText(),
  },
  {
    name: translationService.getDosageFormText(),
    shortName: translationService.getUsText(),
  },
  {
    name: translationService.getDozenText(),
    shortName: translationService.getDzText(),
  },
  {
    name: translationService.getDrumText(),
    shortName: translationService.getDrText(),
  },
]
